<template>
  <div style="margin-top: 67px; background-color: #fafafa;">
    <step :isActivePlan="true"></step>
    <div class="plan-wrapper">
      <b-container>
        <b-row>
          <b-col sm="11" md="6" offset-md="3">
            <div style="padding: 20px;">
              {{firstPayAtYear}}년 {{firstPayAtMonth}}월 {{firstPayAtDay}}일까지
              <router-link
                style="color: #3d4953; text-decoration: underline;"
                :to="{ name: 'FreeTrial'}"
              >
                <span class="bold">무료 체험</span>
              </router-link>
            </div>
            <div class="product-confirm-wrapper" @click="toggle">
              <div class="product-confirm">
                <span>체험제품 확인 / 총{{numberOfCartItems}}개</span>
                <span class="dropdown" v-bind:class="{showDropDown: isItemOpen}">
                  <img style="width: 15px; height: 9px;" src="@/assets/btn-dropdown-plan.png">
                </span>
              </div>
              <div
                v-for="(item, index) in cartItems"
                :key="index"
                class="hidden cart-item"
                v-bind:class="{open: isItemOpen}"
              >
                <div class="left-item-info">
                  <img style="width: 45px;" :src="item.iconUrl" alt>
                  <span>{{item.name}}</span>
                </div>
                <span>₩{{item.price}}</span>
              </div>
            </div>
            <div class="plan-list-wrapper">
              <div
                class="plan lump_sum"
                v-bind:class="{plan_choosed: isLumpSum}"
                @click="planClicked('lump_sum')"
              >
                <div class="plan-info">
                  <span>
                    한달 무료 체험 후
                    <br>
                    <span class="bold">일시불 결제</span>할게요
                  </span>
                  <p v-bind:class="{hidden: isDetailOpenLumpsum}">
                    간편
                    <span style="color: #6f97fa;">1회</span> 결제
                  </p>
                  <p v-bind:class="{hidden: !isDetailOpenLumpsum}">
                    - 1년 무상 교환 및 A/S
                    <br>- 체험 중 언제든 무료 반품
                  </p>
                </div>
                <div class="price-info">
                  <span
                    class="amount"
                    v-bind:class="{hidden: !isDetailOpenLumpsum}"
                  >{{amount}}원</span>
                  <!-- <p
                    class="final-price"
                    v-bind:class="{hidden: !isDetailOpenLumpsum}"
                  >할인가: {{discountedAmount}}원</p>
                  <router-link
                    style="color: #3d4953; text-decoration: underline;"
                    :to="{ name: 'Cash'}"
                  >
                    <p style="font-size: 12px;" v-bind:class="{hidden: !isDetailOpenLumpsum}">*할인 받는법 보러가기(클릭)</p>
                  </router-link> -->
                  <span
                    class="open-detail-text"
                    v-bind:class="{hidden: isDetailOpenLumpsum}"
                    @click="lumpSumDetailClick"
                  >자세히</span>
                </div>
              </div>
              <div
                class="plan lease"
                v-bind:class="{plan_choosed: isLease}"
                @click="planClicked('lease')"
              >
                <div class="plan-info">
                  <span>
                    한달 무료 체험 후
                    <br>
                    <span class="bold">7개월 분할 결제</span>할게요
                  </span>
                  <p v-bind:class="{hidden: isDetailOpenLease}">
                    안심
                    <span style="color: #6f97fa;">분할</span> 결제
                  </p>
                  <ul v-bind:class="{hidden: !isDetailOpenLease}">
                    <li>
                      <p>
                        - 1년 무상 교환 및 A/S
                        <br>- 체험 중 언제든 무료 반품
                      </p>
                    </li>
                    <li>
                      <p style="display:inline-block; margin: 0;">
                        - 7개월 후 소유권 이전
                        <br>- 보증금, 중도해지 위약금 없는 리스
                      </p>
                    </li>
                  </ul>
                </div>
                <span class="amount" v-bind:class="{hidden: !isDetailOpenLease}">{{leaseAmount}}원/월</span>
                <span
                  class="open-detail-text"
                  v-bind:class="{hidden: isDetailOpenLease}"
                  @click="leaseDetailClick"
                >자세히</span>
              </div>
            </div>
            <div class="plan-choise-wrapper">
              <p>모든 결제는 한 달 뒤인 {{firstPayAtYear}}년 {{firstPayAtMonth}}월 {{firstPayAtDay}}일 이후 발생합니다.</p>
              <button class="apply" @click="planChoose">체험플랜 선택하기</button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import Step from './Step'
import AppFooter from '../AppFooter'
import {PAYMENT_METHOD_BY_NUM} from '../../modules/payment_methods.js'
import {convertProductNameFrom} from '../../modules/products'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'plan',
  components: { Step, AppFooter },
  data () {
    return {
      isItemOpen: false,
      isLumpSum: true,
      isLease: false,
      firstPayAtYear: '',
      firstPayAtMonth: '',
      firstPayAtDay: '',
      isDetailOpenLumpsum: false,
      isDetailOpenLease: false
    }
  },
  methods: {
    toggle: function () {
      this.isItemOpen = !this.isItemOpen
    },
    planClicked: function (plan) {
      switch (plan) {
        case 'lump_sum':
          this.isLease = false
          this.isLumpSum = true
          break
        case 'lease':
          this.isLumpSum = false
          this.isLease = true
          break
      }
    },
    storeProduct: function () {
      for (var i = 0; i < this.cartItems.length; i++) {
        this.$store.commit('addApplicantProduct', this.cartItems[i].id)
      }
    },
    storePaymentMethod: function () {
      if (this.isLumpSum) {
        this.$store.commit({
          type: 'addApplicantInfo',
          key: 'paymentMethod',
          value: PAYMENT_METHOD_BY_NUM.LUMP_SUM
        })
      } else if (this.isLease) {
        this.$store.commit({
          type: 'addApplicantInfo',
          key: 'paymentMethod',
          value: PAYMENT_METHOD_BY_NUM.LEASE
        })
      }
    },
    leaseDetailClick: function () {
      this.isDetailOpenLease = !this.isDetailOpenLease
    },
    lumpSumDetailClick: function () {
      this.isDetailOpenLumpsum = !this.isDetailOpenLumpsum
    },
    async planChoose () {
      if (this.numberOfCartItems === 0) {
        this.$dialogs.alert('장바구니에 담긴 제품이 없습니다 ! 제품을 먼저 골라주세요.', alertOptions)
        return
      }
      let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
      if (eventInfo.status === 204) {
        this.$dialogs.alert('무료체험이 매진되었습니다. 곧 다시 모집할테니 걱정마세요!', alertOptions)
        return
      }
      let stockInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/' + eventInfo.data.id + '/stocks/')
      for (var i = 0; i < this.cartItems.length; i++) {
        for (var j = 0; j < stockInfo.data.results.length; j++) {
          if (stockInfo.data.results[j].product_id === this.cartItems[i].id) {
            if (stockInfo.data.results[j].available_quantity === 0) {
              let name = convertProductNameFrom(this.cartItems[i].id)
              this.$dialogs.alert(name + '는 품절되었습니다.', alertOptions)
              return
            }
          }
        }
      }
      if (this.isLease) {
        if (eventInfo.data.available_lease_quantity < this.cartItems.length) {
          this.$dialogs.alert('앗! 분할 결제 방식은 매진되었습니다. 일시불 방식으로 신청은 어떠세요?', alertOptions)
          return
        }
      }
      this.$http.get(process.env.URL_SALES_SERVICE + '/v1/events/advertising/')
        .then((result) => {
          if (result.status === 200) {
            this.storePaymentMethod()
            this.storeProduct()
            this.$router.push({ name: 'Customer' })
          } else if (result.status === 204) {
            this.$dialogs.alert('무료체험 물량이 모두 소진되었습니다.', alertOptions)
            this.$router.push({ path: '/' })
          }
        })
    }
  },
  mounted () {
    this.$store.commit('initApplicantData')
    this.$store.commit('calculateAmounts')
    this.$http.get(process.env.URL_SALES_SERVICE + '/v1/events/advertising/')
      .then((result) => {
        if (result.status === 200) {
          this.$store.commit('updateFirstPayAt', result.data.end_free_trial_at.split('T')[0])
          this.$store.commit('updateDeliveryAt', result.data.delivery_at.split('T')[0])
          this.firstPayAtYear = this.firstPayAt.split('-')[0]
          this.firstPayAtMonth = this.firstPayAt.split('-')[1]
          this.firstPayAtDay = this.firstPayAt.split('-')[2]
        } else if (result.status === 204) {
          this.$dialogs.alert('무료체험 물량이 모두 소진되었습니다.', alertOptions)
          this.$router.push({ path: '/' })
        }
      })
  },
  computed: {
    cartItems () {
      return this.$store.state.cartItems
    },
    numberOfCartItems () {
      return this.$store.state.numberOfCartItems
    },
    firstPayAt () {
      return this.$store.state.firstPayAt
    },
    amount () {
      return this.$store.state.amount
    },
    leaseAmount () {
      return this.$store.state.leaseAmount
    },
    discountedAmount () {
      return this.$store.state.discountedAmount
    }
  }
}
</script>

<style scoped>

.cart-item {
  align-items: center;
  justify-content: space-between;
  padding: 20px 50px 20px 50px;
  font-size: 14px;
  border-bottom: solid 1px #f1f5f7;
  height: 86px;
}
@media (max-width: 320px) {
    .cart-item {
      padding: 20px 30px 20px 30px;
    }
  }
.left-item-info {
  display: flex;
  align-items: center;
}
.left-item-info span {
  margin-left: 20px;
}
.hidden {
  display: none;
}
.open {
  display: flex;
}
.product-confirm-wrapper {
  width: 100%;
  border-radius: 4px;
  display: inline-block;
  background-color: #ffffff;
  cursor: pointer;
}

.product-confirm {
  padding: 30px;
  display: flex;
  justify-content: space-between;
}

.plan-wrapper {
  margin-top: 20px;
  margin-bottom: 100px;
}

.plan-list-wrapper {
  margin-top: 30px;
}

.plan-list-wrapper .plan {
  padding: 20px;
  display: flex;
  border-radius: 4px;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
  background-color: #ffffff;
  cursor: pointer;
}

.plan-list-wrapper .plan .plan-info {
 text-align: left;
}

.plan-list-wrapper .plan .plan-info ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.plan-list-wrapper .plan .plan-info p {
  margin: 10px 0px 0px 0px;
  font-size: 12px;
  line-height: 1.67;
  letter-spacing: -0.2px;
}

.plan-list-wrapper .plan .price-info {
  text-align: right;
}

.plan-list-wrapper .plan .amount {
  font-size: 16px;
}

.plan-choise-wrapper {
  margin-top: 40px;
  font-size: 12px;
  color: #85888b;
}

.plan-choise-wrapper p {
  margin: 0;
}

.plan_choosed {
  border: solid 2px #6f97fa;
  padding: 18px !important;
}

.apply {
  width: 240px;
  height: 50px;
  position: relative;
  vertical-align: middle;
  font-family: "Noto Sans KR", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  color: #ffffff !important;
  background-color: #6f97fa;
  text-decoration: none;
  margin-top: 10px;
  display: inline-block;
  line-height: 28px;
  cursor: pointer;
}

.apply:hover {
  background-color: #5686fe;
}
.dropdown {
  transition: 0.5s;
}
.showDropDown {
  -webkit-transform:rotate(180deg);
}

.open-detail-text {
  font-size: 12px;
}
.final-price {
  color: #fe7578;
  margin: 0;
}

.cancel-line {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/apply/Plan.vue